package pl.mothdigital.neuronowi.components.text

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

val H3Style = TextBaseStyle.extendedBy {
    base {
        Modifier
            .fontSize(20.px)
            .lineHeight(28.px)
            .fontWeight(FontWeight.Medium)
            .margin(topBottom = 0.25.cssRem)
    }
    until(Breakpoint.MD) {
        Modifier
            .fontSize(18.px)
            .lineHeight(26.px)
    }
    until(Breakpoint.SM) {
        Modifier
            .fontSize(16.px)
            .lineHeight(24.px)
    }
}

@Composable
fun AppH3(
    modifier: Modifier = Modifier,
    color: Color = SiteTheme.green._900,
    content: @Composable () -> Unit = {},
) {
    H3(H3Style.toModifier().color(color).then(modifier).toAttrs()) { content() }
}
